import { Component, Input, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { of, lastValueFrom } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BarManagementService, Organization } from 'src/app/api/api-bar-management.service.generated';
import { Advertiser, CampaignsAdvertiserAdminApiClient, CreateAdvertiserRequestDto } from 'src/app/api/api-campaigns.service.generated';
import { AdvertiserOrganizationsSearchComponent } from '../advertiser-organizations-search/advertiser-organizations-search.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatGridListModule } from '@angular/material/grid-list';
import { ButtonComponent, ConfirmDialogModel, DataTableComponent, TableColumn } from 'wecheer-common';
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
  selector: 'app-advertiser-organizations',
  templateUrl: './advertiser-organizations.component.html',
  styleUrls: ['./advertiser-organizations.component.scss'],
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatGridListModule,
    ButtonComponent,
    DataTableComponent,
    MatProgressBar
]
})
export class AdvertiserOrganizationsComponent implements OnInit {
  private advertiserApi = inject(CampaignsAdvertiserAdminApiClient);
  private bmApi = inject(BarManagementService);
  private dialog = inject(MatDialog);

  _advertiser: Advertiser;
  get advertiser() { return this._advertiser; }
  @Input() set advertiser(value: Advertiser) {
    this._advertiser = value;
    this.refresh();
  }
  isLoading = false;

  organizations: Organization[];
  columns: TableColumn[] = [
    {
      name: 'name',
      header: 'Name',
    },
    {
      name: 'description',
      header: 'Description',
    },
    {
      name: 'actions',
      header: '',
      actionButtons: [
        { icon: 'delete', color: 'primary', tooltip: 'Remove Organization', handler: (org: Organization) => this.onRemove(org) }
      ]
    }
  ]

  ngOnInit() { }

  async refresh() {
    if (!this.advertiser)
      return;
    const ids = this.advertiser.organizationIds ? this.advertiser.organizationIds.map(id => +id) : [];
    this.organizations = await lastValueFrom(
      of(ids).pipe(switchMap(orgIds => this.bmApi.getOrganizationsByIds(orgIds)))
    );
  }


  async onAdd() {
    const org = await AdvertiserOrganizationsSearchComponent.open(this.dialog, undefined);
    if (!org) return;

    this.isLoading = true;
    if (!this.advertiser.organizationIds)
      this.advertiser.organizationIds = [];

    this.advertiser.organizationIds = [...this.advertiser.organizationIds, org.id.toString()];
  await lastValueFrom(this.advertiserApi.createOrUpdateAdvertiser(new CreateAdvertiserRequestDto({ advertiser: this.advertiser })));

    this.refresh();

    this.isLoading = false;
  }

  async onRemove(org: Organization) {
    const dialogModel = ConfirmDialogModel.danger(
      'This action cannot be undone. Are you absolutely sure?',
      'Delete Organization?'
    );
    const confirmed = await dialogModel.show(this.dialog);

    if (!confirmed) return;

    this.isLoading = true;
    this.advertiser.organizationIds = this.advertiser.organizationIds.filter(id => id !== org.id.toString());
  await lastValueFrom(this.advertiserApi.createOrUpdateAdvertiser(new CreateAdvertiserRequestDto({ advertiser: this.advertiser })));
    this.refresh();
    this.isLoading = false;
  }
}
